module.exports = __webpack_public_path__ + "media/src/images/icons/eye/opened-d71ec21bb1b8627f641ef652b976e4af.svg";